<template>
<section>
    <div class="d-flex justify-content-center my-2">
      <h1 class="center title">Evenementdetail</h1>
    </div> 
    <form class="container mt-6 ">
        <div class="row">
            <div class="col">
                    <select v-model="selected" @change="selectedValue">
                        <option disabled value="">Please select one</option>
                        <option value="E">Nos événements</option>
                        <option value="T">Team building</option>
                    </select>
                <div class="form-group mt-7">
                    <label>Title</label>
                    <input type="text" class="form-control" v-model="Clients"  >
                </div>
                <div class="form-group">
                    <label for="exampleInputPassword1">Description</label>
                    <textarea type="text" class="form-control"></textarea>
                </div>
                <div class="form-group">
                    <label >Image</label>
                    <input type="file" class="form-control"  @change="setImage">
                </div> 
                <div class="form-group">
                    <label>Video URL</label>
                    <input type="text" class="form-control" v-model="video" >
                </div>
            </div>
        </div> 
        <div class="" v-if="(selected=='E')">
            <div v-for="(profileInput, index) in profileInputs" :key="index" class="row mb-3" >
                <div class="col col-4">
                    <div class="form_groups">
                        <label for="exampleInputPassword1">Text</label>
                        <input type="text" class="form-control w-75 mt-2" v-model="profileInput.value">
                    </div>
                </div>
                <div class="col col-4">
                    <div class="form_groups">
                        <label for="exampleInputPassword1">Number</label>
                        <input type="text" class="form-control w-75 mt-2" v-model="profileInput.key">
                    </div>
                </div>
                <div class="col col-4 trash">
                    <i class="fa-solid fa-trash icon w-15" @click="DeleteProfile(index)" v-if="profileInputs.length > 1"></i>
                </div>
            </div>
            <i class="fa-solid fa-plus icon mt-2" @click="AddProfile" ></i>
        </div>
        
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label >Slide Image</label>
                    <input type="file" class="form-control" name="file[]" multiple/>
                </div> 
            </div>
        </div>
        <button type="submit" class="btn  btn-light me-2" >Enregistrer</button>
    </form>
</section>
</template>
<script>

export default {
    name: "Recrute",
    data() {
        return {
            selected: "",
            profileInputs: [
                {key: "", value: ""}
            ],
        };
    },
    created(){
    },
    methods : {
        selectedValue() {
            console.log(this.selected)
        },
        AddProfile() {
            this.profileInputs.push({value: ""})
        },
        DeleteProfile(index) {
            this.profileInputs.splice(index, 1)
        },
    }
}
</script>

<style lang="scss" scoped>
.title{
    color:white;
}

.btn-light{
    background-color: black;
    color: white;
}
.btn-primary{
    background-color:white;
    color:#A68D5B;
    &:hover{
        background:white;
        color:#A68D5B;
    }
}

.icon{
    background: #A68D5B;
    color: white;
    width: 8%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    cursor: pointer;
    margin-bottom:2%;
}
.trash{
    margin-top:4%;
    margin-left: -6%;
}
.drop{
    color:white;
}
select{
    height: 35px;
    outline: none;
}

</style>


<!-- if this .selected=='E' -->